import React from 'react';

const Newgroup = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 22" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Newgroup_a"
        d="M36.75 103.77v-.22l.07-.2.26-.73h-1.14l1.59-4.64h1.16l.54-1.55h-1.7c-.71 0-1.28.4-1.52 1.02l-2.21 6.36.02 8.53c0 .59.48 1.11 1.06 1.11h.96c.4 0 .75-.28.93-.64z"
      />
      <path id="Newgroup_b" d="M32.27 104.04v-.17l.05-.16.2-.55h-.88l1.22-3.56h.9l.4-1.19h-1.3c-.55 0-.98.3-1.16.78l-1.7 4.88.01 6.54c0 .45.37.85.82.85h.74c.3 0 .57-.2.7-.49z" />
      <path
        id="Newgroup_c"
        d="M52.11 97.13h-9.64l-1.81 5.27h18.16c.3.86.51 1.36.51 1.36v7.28l-.01 2.4c0 .68-.55 1.27-1.22 1.27h-1.07c-.67 0-1.21-.66-1.21-1.33v-2.18H41.75v2.18c0 .67-.53 1.33-1.2 1.33h-1.09c-.67 0-1.21-.6-1.21-1.26l-.02-9.7 2.51-7.22c.27-.7.92-1.16 1.73-1.16h9.64zm-10.36 10.55c.96 0 1.76-.8 1.76-1.76a1.76 1.76 0 0 0-3.52 0c0 .97.79 1.76 1.76 1.76zm14.06 0a1.76 1.76 0 0 0 0-3.5c-.96-.01-1.75.78-1.75 1.74 0 .97.79 1.76 1.75 1.76z"
      />
      <path id="Newgroup_d" d="M59.92 95.43H57.5V93h-1.6v2.43h-2.43v1.6h2.43v2.42h1.6v-2.43h2.42z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Newgroup_a" transform="translate(-30 -93)" />
    <use fill="currentColor" xlinkHref="#Newgroup_b" transform="translate(-30 -93)" />
    <use fill="currentColor" xlinkHref="#Newgroup_c" transform="translate(-30 -93)" />
    <use fill="currentColor" xlinkHref="#Newgroup_d" transform="translate(-30 -93)" />
  </svg>
);

export default Newgroup;



// WEBPACK FOOTER //
// ./src/common/icons/Newgroup.js